import { render } from "./Calender.vue?vue&type=template&id=38476c56"
import script from "./Calender.vue?vue&type=script&lang=js"
export * from "./Calender.vue?vue&type=script&lang=js"
script.render = render

export default script